
export function rotateBase64Image(base64data: string, callback: (data: string) => void) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d")!;
    const image = new Image();
    image.src = base64data;
    image.onload = function () {
        canvas.height = image.width;
        canvas.width = image.height;
        ctx.translate(image.height / 2, image.width / 2);
        ctx.rotate((90 * Math.PI) / 180);
        ctx.drawImage(image, -image.width / 2, -image.height / 2);
        callback(canvas.toDataURL("image/jpeg"));
    };
}